import { memo } from 'react';

import { ComponentContextProps, merge, renderWithContext, useComponent } from '@/components';
import { DivProps } from '@/utils';

export type FlexProps = DivProps &
  Partial<ComponentContextProps> & {
    col?: boolean;
  };

const IFlex = ({ variant, col, className, children, ...rest }: FlexProps) => {
  const context = useComponent({ variant });

  /* prettier-ignore */
  const styles = [
    'flex',
    col && 'flex-col',
    /* Force size to be defined across main axis */
    col ? 'min-h-0' : 'min-w-0',
  ];

  /* prettier-ignore */
  const plainStyles: string[] = [];

  /* prettier-ignore */
  const primaryStyles = [
    'bg-primary-25',
    'border-primary-100',
    'border-1',

    /* Tooltip */
    'group-[*]/tooltip:bg-transparent',
    'group-[*]/tooltip:border-none',
  ];

  /* prettier-ignore */
  const secondaryStyles = [
    'bg-white',
    'border-gray-200',
    'border-1',
  ];

  /* prettier-ignore */
  const successStyles = [
    'bg-success-50',
    'border-success-100',
    'border-1',
  ];

  /* prettier-ignore */
  const warningStyles = [
    'bg-warning-25',
    'border-warning-100',
    'border-1',
  ];

  /* prettier-ignore */
  const errorStyles = [
    'bg-error-50',
    'border-error-100',
    'border-1',
  ];

  /* prettier-ignore */
  const exportStyles = [
    'bg-export-50',
    'border-export-100',
    'border-1',
  ];

  return (
    <div
      className={merge(
        styles,
        context.variant === 'default' && plainStyles,
        context.variant === 'plain' && plainStyles,
        context.variant === 'primary' && primaryStyles,
        context.variant === 'secondary' && secondaryStyles,
        context.variant === 'success' && successStyles,
        context.variant === 'warning' && warningStyles,
        context.variant === 'error' && errorStyles,
        context.variant === 'export' && exportStyles,
        className
      )}
      {...rest}
    >
      {renderWithContext(children, context)}
    </div>
  );
};

export const Flex = memo(IFlex) as typeof IFlex;
